import { DefaultNotificationService } from './job-complete-message-services/default-notification-service';

class SellerMaintenanceNotificationServiceClass {
  processMessage(message) {
    DefaultNotificationService.displayNotification(message.Notification);
  }
}

export const SellerMaintenanceNotificationService = new SellerMaintenanceNotificationServiceClass();
